<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="inputValue.state"
    :invalid-feedback="inputValue.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <b-form-input
      :id="id"
      v-model="inputValue.value"
      :type="type"
      :maxlength="maxLength"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="isDisabled"
      :state="inputValue.state"
      v-on:change="removeInvalidFeedback">
    </b-form-input>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>
export default {
  name: 'StringField',

  props: {
    inputValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    maxLength: {
      type: Number,
      default: 250
    },
    placeholder: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  methods: {

    removeInvalidFeedback () {
      this.inputValue.state = null
      this.inputValue.invalidFeedback = null
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/StringField.vue